<template>
    <v-toolbar dark color="primary">
        <v-btn @click="goBack('units')" icon text>
            <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title>
            <v-list two-line color="transparent">
                <v-list-item class="px-0 selectable">
                    <v-list-item-avatar>
                        <v-icon>shopping_basket</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content v-if="unit">
                        <v-list-item-title>
                                <span
                                    class="title mr-5 unit-header-left-col"
                                >{{ unit.number }} {{department}}</span>
                            <span class="subtitle-1">{{ configTitle }}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                                <span
                                    class="subtitle-1 mr-5 white--text unit-header-left-col"
                                >{{ unit.garage }}</span>
                            <span class="subtitle-2">{{ subTitle }}</span>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
  import Back from '../Back.vue';
  import moment from 'moment';
  import { DateFormat } from '@/plugins/date-filter';

  export default {
    props: {unit: {required: true}},
    mixins: [Back],
    name: 'ContainerToolbar',
    computed: {
      department() {
        if (!this.unit.department) {
          return '';
        }
        return `(${this.unit.department})`;
      },
      configTitle() {
        if (!this.unit.containerConfiguration && !this.unit.containerDetail) {
          return;
        }
        const configs = [];
        if (!!this.unit.containerConfiguration) {
          configs.push(this.unit.containerConfiguration.name);
        }
        if (!!this.unit.containerDetail) {
          configs.push(this.unit.containerDetail.containerSize);
        }

        return `${configs.join(' - ')}`;
      },
      formattedDate() {
        return this.unit.firstDayOfService ? moment(this.unit.firstDayOfService).format(DateFormat.DefaultDisplay) : '';
      },
      subTitle() {
        const details = [];
        if (!!this.unit.containerDetail && !!this.unit.containerDetail.alternateNumber) {
          details.push('Alternate# - ' + this.unit.containerDetail.alternateNumber);
        }
        if (!!this.unit.containerDetail && !!this.unit.containerDetail.description) {
          details.push('Description - ' + this.unit.containerDetail.description);
        }
        return `${details.join('\xa0\xa0\xa0')}` + '\xa0\xa0\xa0Manufactured - ' + moment(this.unit.firstDayOfService).format(DateFormat.DefaultDisplay);
      }
    }
  };
</script>

<style scoped>

</style>
